<ng-container [ngTemplateOutlet]="contentTemplate" *ngIf="plain"></ng-container>

<mat-card appearance="outlined" *ngIf="!plain">
  <mat-card-header>
    <mat-card-title>{{ 'PAGE_PAGES.PRIMARY_IMAGE' | translate }}</mat-card-title>
  </mat-card-header>
  <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ control: control }"></ng-container>
</mat-card>

<ng-template #contentTemplate>
  <img mat-card-image class="m-0" *ngIf="control?.value" [src]="(control.value | secureImg) + '&stream=up'" />

  <mat-card-actions>
    <button mat-button type="button" (click)="selectPrimaryImage()">{{ 'COMMON.CHOOSE_IMAGE' | translate }}</button>
    <button mat-button type="button" color="warn" (click)="removePrimaryImage()" *ngIf="control.value">
      {{ 'MEDIA.DELETE' | translate }}
    </button>
  </mat-card-actions>
</ng-template>
